enum AddonCycleEnum {
    BOTH,
    YEARLY,
    MONTHLY,
    ONE_TIME,
    CUSTOM
}

export default AddonCycleEnum
